// Centralized ticket types by bookingType

const ticketTypesByBookingType = {
    // Kindergeburtstage
    birthday: {
        eventGroupId: 3553,
        minQuantity: 1,
        maxQuantity: 60,
        title: {
            de: "Kindergeburtstag",
            en: "Kindergeburtstag"
        },
        supervisorRules: {
            childrenPerSupervisor: 8,
            childTicketCodes: ["child", "bday small child"],
            supervisorTicketCodes: ["adult"]
        },
        items: [
            {
                id: 1,
                price: 23.00,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "adult",
                isSupervisor: true,
                info: {
                    name: {
                        de: "Erwachsene",
                        fr: "adultes",
                        en: "Adults",
                        it: "adulti"
                    }
                },
            },
            {
                id: 2,
                price: 19.00,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "aprendice",
                info: {
                    name: {
                        de: "Schüler:innen | Lernende",
                        fr: "Élèves | Apprenants",
                        en: "School pupils | Learners",
                        it: "Studenti | Allievi"
                    }
                },
            },
            {
                id: 3,
                price: 16.00,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "child",
                isChild: true,
                info: {
                    name: {
                        de: "Kinder (6 - 16 Jahren)",
                        fr: "enfants (6 à 16 ans)",
                        en: "Children (aged 6–16)",
                        it: "bambini (6-16 anni)",
                    }
                },
            },
            {
                id: 4,
                price: 5.00,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "bday small child",
                isChild: true,
                info: {
                    name: {
                        de: "Kleinkind (2 - 5 Jahren)",
                        fr: "tout-petits (2 à 5 ans)",
                        en: "Toddlers (2–5 years old)",
                        it: "bambini piccoli (2-5 anni)",
                    }
                },
            },
        ]
    },
    // Schulgruppen
    schoolgroup: {
        eventGroupId: 3553,
        minQuantity: 1,
        maxQuantity: 60,
        title: {
            de: "Schulen",
            en: "Schulen"
        },
        supervisorRules: {
            childrenPerSupervisor: 8,
            childTicketCodes: ["school children"],
            supervisorTicketCodes: ["school adult"],
            freeCompanionTickets: 1  // One free companion ticket automatically added
        },
        items: [
            {
                id: 1,
                price: 23.00,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "school adult",
                isSupervisor: true,
                info: {
                    name: {
                        de: "Erwachsene | Lehrperson | Begleitperson",
                        fr: "Adultes | Enseignant(e) | Accompagnateur / Accompagnatrice",
                        en: "Adults | Teacher | Accompanying person",
                        it: "Adulti | Insegnante | Accompagnatore / Accompagnatrice"
                    }
                },
            },
            {
                id: 2,
                price: 16.00,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "school children",
                isChild: true,
                info: {
                    name: {
                        de: "Schüler:innen (6-16 Jahren)",
                        fr: "élèves (6-16 ans)",
                        en: "Schoolchildren (aged 6–16)",
                        it: "studenti (6-16 anni)"
                    }
                },
            },
            { 
                id:3,
                price: 19.00,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "aprendice",
                info: {
                    name: {
                        de: "Schüler:innen | Lernende",
                        fr: "Élèves | Apprenants",
                        en: "School pupils | Learners",
                        it: "Studenti | Allievi"
                    }
                },
            },
            //{
            //    id: 4,
            //    price: 5.00,
            //    currency: "CHF",
            //    quantity: 1,
            //    externalTicketCode: "school companion",
            //    info: {
            //        name: {
            //            de: "Begleitperson",
            //            fr: "Personne accompagnante",
            //            en: "Companion",
            //            it: "Accompagnatore / Accompagnatrice"
            //        }
            //    },
            //}
        ]
    },
    // Gruppenbesuch
    groupvisit: {
        eventGroupId: 3553,
        minQuantity: 1,
        maxQuantity: 60,
        title: {
            de: "Gruppenbesuch",
            en: "Gruppenbesuch"
        },
        items: [
            {
                id: 1,
                price: 23.00,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "adult",
                info: {
                    name: {
                        de: "Erwachsene",
                        fr: "adultes",
                        en: "Adults",
                        it: "adulti"
                    }
                },
            },
            {
                id: 2,
                price: 19.00,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "aprendice",
                info: {
                    name: {
                        de: "Schüler:innen | Lernende | Studierende",
                        fr: "Élèves | Apprenants",
                        en: "School pupils | Learners",
                        it: "Studenti | Allievi"
                    }
                },
            },
            {
                id: 3,
                price: 16.00,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "child",
                info: {
                    name: {
                        de: "Kinder (6 - 16 Jahren)",
                        fr: "enfants (6 à 16 ans)",
                        en: "Children (aged 6–16)",
                        it: "bambini (6-16 anni)",
                    }
                },
            },
            {
                id: 5,
                price: 5.00,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "bday small child",
                info: {
                    name: {
                        de: "Kleinkind (2 - 5 Jahren)",
                        fr: "tout-petits (2 à 5 ans)",
                        en: "Toddlers (2–5 years old)",
                        it: "bambini piccoli (2-5 anni)",
                    }
                },
            },
            {
                id: 6,
                price: 16.10,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "group kulturlegi adult",
                isDiscountTicketType: true,
                info: {
                    name: {
                        de: "KulturLegi Erwachsene",
                        fr: "Kulturlegi adultes",
                        en: "Kulturlegi Adults",
                        it: "Kulturlegi adulti",
                    }
                },
            },
            {
                id: 7,
                price: 13.30,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "group kulturlegi student",
                isDiscountTicketType: true,
                info: {
                    name: {
                        de: "KulturLegi Schüler:innen, Studierende, Lehrlinge, IV",
                        fr: "Kulturlegi Élèves, étudiants, apprentis, AI",
                        en: "KulturLegi pupils, students, apprentices, IV",
                        it: "KulturLegi Studenti, apprendisti, IV",
                    }
                },
            },
            {
                id: 8,
                price: 11.20,
                currency: "CHF",
                quantity: 60,
                externalTicketCode: "group kulturlegi child",
                isDiscountTicketType: true,
                info: {
                    name: {
                        de: "KulturLegi Kinder (6 - 16 Jahre)",
                        fr: "KulturLegi Enfants (6 à 16 ans)",
                        en: "KulturLegi children (aged 6–16)",
                        it: "KulturLegi Bambini (6 - 16 anni)",
                    }
                },
            },
        ]
    }
};

export default ticketTypesByBookingType;
